<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="isValid" ref="form">
          <v-card>
            <v-toolbar color="white" fixed>
              <h3>{{ $i18n.t(label) }}</h3>
            </v-toolbar>
            <v-card-text>
              <v-container class="py-0">
                <v-row class="mt-4">
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Name')"
                      dense
                      v-model="entity.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Short Code')"
                      dense
                      v-model="entity.shortCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      :label="$i18n.t('Type')"
                      dense
                      v-model="entity.type"
                      :items="[
                        { name: 'Private Limited', value: 1 },
                        { name: 'Partnership', value: 2 },
                        { name: 'Individual', value: 3 },
                        { name: 'LLP', value: 4 },
                      ]"
                      item-text="name"
                      item-value="value"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("Corporate Details") }}</h3>
                  </v-btn>
                  <v-row style="padding: 10px 10px">
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Corporate Name')"
                        dense
                        v-model="entity.corporate.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Corporate Email')"
                        dense
                        v-model="entity.corporate.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Corporate Phone')"
                        dense
                        v-model="entity.corporate.phone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('TAN')"
                        dense
                        v-model="entity.corporate.tan"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('PAN')"
                        dense
                        v-model="entity.corporate.pan"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('CIN')"
                        dense
                        v-model="entity.corporate.cin"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Service Tax')"
                        dense
                        v-model="entity.corporate.service_Tax_No"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('ESIC')"
                        dense
                        v-model="entity.corporate.esic"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('EPFO')"
                        dense
                        v-model="entity.corporate.epfo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="entity.rcmApplicable"
                        :label="$i18n.t('RCM Applicable')"
                      />
                    </v-col>
                  </v-row>
                </v-card>
                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("Invoice Details") }}</h3>
                  </v-btn>
                  <v-row style="padding: 10px 10px">
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Invoice Email')"
                        dense
                        v-model="entity.invoiceEmail"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Invoice Phone No')"
                        dense
                        v-model="entity.invoicePhone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Other Phone No')"
                        dense
                        v-model="entity.otherInvoicePhone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Invoice Due Period')"
                        dense
                        type="number"
                        v-model="entity.duePeriod"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("Contact Person") }}</h3>
                  </v-btn>
                  <v-btn
                    x-small
                    color="blue"
                    class="right-headers"
                    style="float: right"
                    v-on:click="addItem(entity.contactPeople)"
                    >+ {{ $i18n.t("Add ") }}</v-btn
                  >

                  <v-row
                    v-for="(person, index) in entity.contactPeople" :key="person.name"
                    style="padding: 10px 10px"
                  >
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Name')"
                        dense
                        v-model="person.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Contact Person Type')"
                        dense
                        v-model="person.type"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Contact Person Designation')"
                        dense
                        v-model="person.designation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <z-country-select
                        :label="$i18n.t('Country Code') + '*'"
                        class="purple-input"
                        v-model="person.countryCode"
                        isd
                        hideName
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        :label="$i18n.t('Mobile')"
                        type="number"
                        v-model="person.mobile"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Email')"
                        v-model="person.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-btn @click="remove(index)" fab small text color="error">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("GST Details") }}</h3>
                  </v-btn>
                  <v-row
                    style="padding: 10px 10px"
                    v-for="config in entity.taxConfigs"
                    :key="config._id"
                  >
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('GSTIN')"
                        dense
                        v-model="entity.gstin"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Service Code')"
                        dense
                        v-model="config.serviceCode"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Service Label')"
                        dense
                        v-model="config.title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('State Code')"
                        dense
                        v-model="config.stateCode"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('LUT NO.')"
                        dense
                        v-model="config.lutNo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Invoice Prefix')"
                        dense
                        v-model="entity.invoicePrefix"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Invoice Prefix SEZ')"
                        v-model="entity.invoicePrefixSEZ"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Minimum Invoice Sequence')"
                        v-model="entity.minInvSeq"
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="entity.resetInvoiceNoInApril"
                        :label="$i18n.t('Reset Invoice Number in April')"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="entity.underSEZ"
                        :label="$i18n.t('Under SEZ')"
                      />
                    </v-col>
                    <!-- <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="entity.distinctSeries"
                        :label="$i18n.t('Distinct Invoice No. Series')"
                      />
                    </v-col> -->
                  </v-row>
                </v-card>

                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("Bank Account Detail") }}</h3>
                  </v-btn>
                  <v-row style="padding: 10px 10px">
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Account Name')"
                        dense
                        v-model="entity.bankAccount.holderName"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Account Number')"
                        dense
                        v-model="entity.bankAccount.accountNo"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Bank Name')"
                        dense
                        v-model="entity.bankAccount.bankName"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('IFSC Code')"
                        dense
                        v-model="entity.bankAccount.ifsc"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :label="$i18n.t('Swift Code')"
                        dense
                        v-model="entity.bankAccount.swiftCode"
                      />
                    </v-col>
                  </v-row>
                </v-card>
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select
                      class="purple-input"
                      v-model="entity.address.country"
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-state-select
                      class="purple-input"
                      v-model="entity.address.state"
                      :country="entity.address.country"
                    ></z-state-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <z-city-select
                      class="purple-input"
                      v-model="entity.address.city"
                      :state="entity.address.state"
                      :country="entity.address.country"
                    ></z-city-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="$i18n.t('Address')"
                      dense
                      v-model="entity.address.addressLine"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="$i18n.t('Pin Code')"
                      dense
                      v-model="entity.address.pinCode"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div style="top:-275px; width:50px;position:relative; margin:auto">
                      <v-icon style="font-size: 50px;" color="red">mdi-map-marker</v-icon>
                    </div>
                  </v-row>
            </v-col>-->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <v-btn
                text
                fab
                small
                color="teal lighten-2"
                :title="$i18n.t('Audit Logs')"
                @click="showAuditLog = true"
                v-if="entity.showAuditLog"
              >
                <v-icon>mdi-database</v-icon>
              </v-btn>
              <v-btn
                color="success darken-1"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <z-audit-log
      v-if="entity"
      :showDialog="showAuditLog"
      :entity_id="entity._id"
      entity="Entity"
      @closeAuditLog="showAuditLog = false"
    >
    </z-audit-log>
  </v-container>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "EntityCreate",
  props: {
    label: {
      default: "Create Entity",
    },
    entity_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
    forClient: {
      default: null,
    },
    value: {
      default: null,
    },
  },
})
export default class EntityCreate extends Vue {
  isValid = true;
  isClone = null;
  isEdit = false;
  showAuditLog = false;
  entityPOSO = {
    corp_id: null,
    name: null,
    address: { country: null, state: null, city: null, addressLine: null },
    corporate: {
      name: null,
      email: null,
      phone: null,
      tan: null,
      pan: null,
      cin: null,
      service_Tax_No: null,
      esic: null,
      epfo: null,
    },
    contactPeople: [],
    taxConfigs: [{}],
    bankAccount: {
      swiftCode: null,
      ifsc: null,
      bankName: null,
      accountNo: null,
      holderName: null,
    },
  };

  entity = this.entityPOSO;

  select(data) {
    this.$emit("select", data);
  }

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    fullName: [(v) => !!v || this.$i18n.t("Full Name is required")],
    addressCountry: [(v) => !!v || this.$i18n.t("Country is required")],
    addressCity: [(v) => !!v || this.$i18n.t("City is required")],
    addressState: [(v) => !!v || this.$i18n.t("State is required")],
    addressAddressLine: [(v) => !!v || this.$i18n.t("Address is required")],
    adminName: [(v) => !!v || this.$i18n.t("Admin Name is required")],
    countryCodeAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone Code is required"),
    ],
    phoneAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone no is required"),
      (v) =>
        !isNaN(parseInt(v)) || this.$i18n.t("Admin Phone no should be valid"),
    ],
    email: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  };

  addItem(_list) {
    if (!_list) {
      _list = [];
    }
    _list.push({});
    return _list;
  }

  id = null;

  get loading() {
    return common.loading;
  }

  remove(_index) {
    this.entity.contactPeople.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/config/save/entity", this.entity);
      common.showMessage(`Entity ${response.name} Saved Successfully`);
      common.setLoading(false);

      if (this.singlePage) {
        this.$emit("select", {
          name: response.name,
          _id: response._id,
        });
        this.entity = this.entityPOSO;
        this.$emit("reload");
      }
      //  else if (this.isEntityAdd) {
      //   this.$router.push("/entity/" + response._id);
      //   this.get(response._id);
      // }
      else {
        if (!this.id) this.$router.push("/entity/" + response._id);
        this.get(response._id);
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  prepareResponse(response) {
    if (!response) response = {};
    if (!response.name) response.name = null;
    if (!response.shortCode) response.shortCode = null;
    if (!response.type) response.type = null;

    if (!response.corporate) response.corporate = {};
    if (!response.corporate.name) response.corporate.name = null;
    if (!response.corporate.email) response.corporate.email = null;
    if (!response.corporate.phone) response.corporate.phone = null;
    if (!response.corporate.tan) response.corporate.tan = null;
    if (!response.corporate.pan) response.corporate.pan = null;
    if (!response.corporate.cin) response.corporate.cin = null;
    if (!response.corporate.service_Tax_No)
      response.corporate.service_Tax_No = null;
    if (!response.corporate.esic) response.corporate.esic = null;

    if (!response.rcmApplicable) response.rcmApplicable = null;
    if (!response.invoiceEmail) response.invoiceEmail = null;
    if (!response.invoicePhone) response.invoicePhone = null;
    if (!response.otherInvoicePhone) response.otherInvoicePhone = null;

    if (!response.contactPeople) response.contactPeople = [];
    for (let index = 0; index < response.contactPeople.length; index++) {
      if (!response.contactPeople[index].name)
        response.contactPeople[index].name = null;
      if (!response.contactPeople[index].type)
        response.contactPeople[index].type = null;
      if (!response.contactPeople[index].designation)
        response.contactPeople[index].designation = null;
      if (!response.contactPeople[index].countryCode)
        response.contactPeople[index].countryCode = null;
      if (!response.contactPeople[index].mobile)
        response.contactPeople[index].mobile = null;
      if (!response.contactPeople[index].email)
        response.contactPeople[index].email = null;
    }

    if (!response.taxConfigs) response.taxConfigs = [];
    if (response.taxConfigs.length < 1) {
      response.taxConfigs.push({
        serviceCode: null,
        title: null,
        stateCode: null,
        lutNo: null,
      });
    }
    for (let index = 0; index < response.taxConfigs.length; index++) {
      if (!response.taxConfigs[index].serviceCode)
        response.taxConfigs[index].serviceCode = null;
      if (!response.taxConfigs[index].title)
        response.taxConfigs[index].title = null;
      if (!response.taxConfigs[index].stateCode)
        response.taxConfigs[index].stateCode = null;
      if (!response.taxConfigs[index].lutNo)
        response.taxConfigs[index].lutNo = null;
    }

    if (!response.gstin) response.gstin = null;
    if (!response.invoicePrefix) response.invoicePrefix = null;
    if (!response.invoicePrefixSEZ) response.invoicePrefixSEZ = null;
    if (!response.minInvSeq) response.minInvSeq = null;
    if (!response.resetInvoiceNoInApril) response.resetInvoiceNoInApril = null;
    // if (!response.distinctSeries) response.distinctSeries = null;
    if (!response.underSEZ) response.underSEZ = null;

    if (!response.bankAccount) response.bankAccount = {};
    if (!response.bankAccount.holderName)
      response.bankAccount.holderName = null;
    if (!response.bankAccount.accountNo) response.bankAccount.accountNo = null;
    if (!response.bankAccount.bankName) response.bankAccount.bankName = null;
    if (!response.bankAccount.ifsc) response.bankAccount.ifsc = null;
    if (!response.bankAccount.swiftCode) response.bankAccount.swiftCode = null;

    if (!response.address) response.address = {};
    if (!response.address.country) response.address.country = null;
    if (!response.address.state) response.address.state = null;
    if (!response.address.city) response.address.city = null;
    if (!response.address.addressLine) response.address.addressLine = null;
  }

  async get(id) {
    try {
      const entity = await doGet("/api/entity/" + id + "/list");
      this.prepareResponse(entity);
      this.entity = entity;
      this.id = this.entity._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.singlePage) {
      if (this.entity_id) {
        await this.get(this.entity_id);
      }
    } else if (this.value) {
      this.prepareResponse(this.value);
      this.entity = this.value;
      this.id = this.entity._id;
    } else if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    } else if (this.$route.params.clone_id) {
      this.isClone = true;
      await this.get(this.$route.params.clone_id);
      this.entity._id = null;
      this.entity.version = null;
    }
    await init.getUrlParameter("forCorp");
    if (init.urlParam) {
      this.entity.corp_id = init.urlParam;
    }

    if (this.forClient) this.entity.corp_id = this.forClient;
  }
}
</script>

<style scoped>
.left-headers {
  text-transform: none;
  top: -15px;
  left: 10px;
  font-size: 12px;
}
.right-headers {
  text-transform: none;
  top: -10px;
  left: 10px;
  font-size: 12px;
}
</style>
